import { TEmployeeRole, TRESPONSE_EMPLOYEE_LIST } from '@monorepo/types';
import { TDropdownItem, TLiftedFormModel } from '../../model/form.model';
import { PIPELINE_FORM } from '../../model/form.pipeline';
import { FORM_MODIFIER } from '../../model/form.modifier';

export type TEditProfileFormPayload = {
  username: string;
  employeeId: string;
  name: string;
  emailId?: string;
  contactNumber?: string;
  role: TEmployeeRole[number];
  issueCategories: string[];
  machineTypes: string[];
  shiftId?: number[];
};

export type TEditProfileShiftOption = { shiftId: number; shiftName: string; shiftCategory?: string | null };

export const EDIT_PROFILE_FORM_MODEL = {
  createModel: (
    employee: TRESPONSE_EMPLOYEE_LIST['employeesWithAssignments'][number]['employee'],
    isEmpIdEditAllowed: boolean,
    issueCategories: string[],
    issueCategoriesOptions: string[],
    machineTypes: string[],
    machineTypesOptions: string[],
    shiftOpts: TEditProfileShiftOption[],
    shiftOptions: TEditProfileShiftOption[],
  ): TLiftedFormModel => {
    return PIPELINE_FORM.sanitize({
      inputs: [
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: employee.username,
          },
          metadata: {
            keyName: 'username',
            label: 'edit_profile.username',
            isHidden: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: employee.name,
          },
          metadata: {
            keyName: 'name',
            label: 'edit_profile.Name',
            isRequired: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: employee.employeeId,
          },
          metadata: {
            keyName: 'employeeId',
            label: 'edit_profile.EmployeeID',
            isReadonly: !isEmpIdEditAllowed,
            isRequired: true,
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: employee.emailId,
          },
          metadata: {
            keyName: 'emailId',
            label: 'edit_profile.EmailAddress',
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: employee.contactNumber,
          },
          metadata: {
            keyName: 'contactNumber',
            label: 'edit_profile.Phonenumber',
          },
        },
        {
          input: {
            type: 'INPUT',
            subType: 'text',
            value: employee.role,
          },
          metadata: {
            keyName: 'role',
            label: 'edit_profile.Role',
            isReadonly: true,
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            subType: 'text',
            value: issueCategories,
            isMulti: true,
            options: issueCategoriesOptions.map((ic) => ({ displayName: ic, value: ic })),
          },
          metadata: {
            keyName: 'issueCategories',
            label: 'edit_profile.IssueCategories',
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            subType: 'text',
            value: machineTypes,
            isMulti: true,
            options: machineTypesOptions.map((mt) => ({ displayName: mt, value: mt })),
          },
          metadata: {
            keyName: 'machineTypes',
            label: 'edit_profile.MachineTypes',
          },
        },
        {
          input: {
            type: 'DROPDOWN_WITH_SEARCH',
            subType: 'text',
            value: shiftOpts.map((s) => s.shiftId),
            isMulti: true,
            options: shiftOptions.map(
              (s): TDropdownItem => ({
                displayName: s.shiftCategory ? `${s.shiftName} (${s.shiftCategory})` : s.shiftName,
                value: s.shiftId,
              }),
            ),
            placeholder: 'edit_profile.NotAssigned',
          },
          metadata: {
            keyName: 'shiftId',
            label: 'edit_profile.Shift',
          },
        },
      ],
      isValid: false,
    });
  },
  identity: (): TLiftedFormModel => {
    return {
      inputs: [],
    };
  },

  onParentSave: (formModel: TLiftedFormModel): TLiftedFormModel => {
    return FORM_MODIFIER.markTouchedInputs(formModel);
  },
};
